import { render, staticRenderFns } from "./AsfMatrixSelect.vue?vue&type=template&id=65e80c11"
import script from "./AsfMatrixSelect.vue?vue&type=script&lang=js"
export * from "./AsfMatrixSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports